import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'grommet';

export const STATUS_COLORS = {
  pending: { bg: '#f59e0b22', border: '#f59e0b', text: '#f59e0b' },
  running: { bg: '#3b82f622', border: '#3b82f6', text: '#3b82f6' },
  completed: { bg: '#00a85522', border: '#00a855', text: '#00a855' },
  failed: { bg: '#e53e3e22', border: '#e53e3e', text: '#e53e3e' },
};

export function fmt(n) {
  if (n == null) return '—';
  return Number(n).toLocaleString();
}

export function StatusBadge({ status }) {
  const colors = STATUS_COLORS[status] || { bg: '#71717a22', border: '#71717a', text: '#71717a' };
  return (
    <Box
      background={colors.bg}
      border={{ color: colors.border, size: '1px' }}
      round="6px"
      pad={{ vertical: '0.2rem', horizontal: '0.5rem' }}
      width="fit-content"
    >
      <Text size="0.8rem" weight={600} color={colors.text} style={{ textTransform: 'capitalize' }}>
        {status}
      </Text>
    </Box>
  );
}

StatusBadge.propTypes = { status: PropTypes.string.isRequired };
